import { Stack } from 'expo-router';

export default function RoutesTabLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
